import { ORDER_BEHAVIOR, ORDER_TYPE, type IEquity } from '~/api/interface/rights';
import { USER_ADMIN } from '~/constants';
import { showContactNew } from '~/hooks/useModal/modals/contact';
import BaseState, { type ITitleClass } from './base';
import CornerMark from './corner-mark.vue';

/** 团队入门版 */
export default class Rights16 extends BaseState {
  TitleView = defineComponent({
    name: 'TitleView16',
    props: {
      titleClass: {
        type: Object as PropType<ITitleClass>,
        required: true,
      },
      rights: {
        type: Object as PropType<IEquity>,
        required: true,
      },
      hovered: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    setup(props) {
      const { rights } = props;
      const { $t } = useNuxtApp();
      return () => (
        <>
          <div>
            <div class="title-name">{rights.rights_name}</div>
          </div>
          <div class="sub-title">{rights.subject}</div>
          {isChinese() ? <CornerMark text={$t('qi-ye-shang-yong-shou-quan')} /> : null}
        </>
      );
      // const { titleClass, rights } = props
      // const show = ref(false)
      // nextTick(() => {
      //   show.value = true
      // })
      // return () => {
      //   return (
      //     <>
      //       <div class="rights-head">
      //         <div class={titleClass.name}>
      //           <div>{rights.rights_name}</div>
      //         </div>
      //         <div class={[titleClass.number, 'sub-title']}>
      //           {rights.subject}
      //         </div>
      //       </div>
      //     </>
      //   )
      // }
    },
  });

  get PriceView() {
    const YEAR = 12;
    const year = this.rights.rights_by_time.find(
      item => (isChinese() ? !item.buy_type : item.buy_type) && item.months >= YEAR
    );

    if (!year) {
      return null;
    }

    const showYear = getEnv('area') === 'CN';

    const price = showYear ? year.price : year.price / year.months;
    const showPrice = showYear ? year.show_price : year.show_price / year.months;

    const { $t } = useNuxtApp();

    return (
      <div class={!isChinese() ? 'pt-[43px] pb-[16px] w-full' : 'pt-[38px] pb-[34px]'}>
        <div class="flex justify-center items-baseline relative">
          <div
            class={
              !isChinese()
                ? 'flex-1 flex-y-center justify-between text-[#4640B3] w-full'
                : 'flex-1 flex justify-center items-end'
            }
          >
            <div class="flex items-baseline relative discount-price mr-[6px]">
              {this.rights?.hover && !isGlobalVersion() && (
                <div class="rights-extra !left-1/2 !-top-[33px] -ml-[60px]">
                  {this.rights?.hover}
                </div>
              )}
              <div class="price-prefix">{formatPrice(price).prefix}</div>
              <div class="price-num">{formatPrice(price).value}</div>
              <div class="price-suffix">/{showYear ? $t('nian') : $t('yue')}</div>
            </div>
            <div class="base-price">
              {formatPrice(showPrice).string}/{showYear ? $t('nian') : $t('yue')}
            </div>
          </div>
        </div>
      </div>
    );
  }

  get isAdmin() {
    const { userInfo } = this.state;
    if (!userInfo) {
      return false;
    }

    return userInfo.permission >= USER_ADMIN.ORG_ADMIN_USER;
  }

  get ButtonView() {
    const { $t } = useNuxtApp();

    // 国内只能联系顾问
    if (isChinese()) {
      if (this.isUserLogin) {
        return this.getButton({
          text: $t('zi-xun-gu-wen'),
          cb: this.openContact,
        });
      }
      return this.getButton({
        text: $t('le-jie-geng-duo'),
        cb: this.openContact,
      });
    }

    // 海外可以直接购买
    if (this.isSameRights() && this.isAdmin) {
      return this.getButton({
        text: $t('li-ji-xu-fei'),
        cb: this.renewOrder,
      });
    }
    return this.getButton({
      text: $t('li-ji-ding-yue'),
      cb: this.newOrder,
    });
  }

  get StickyButtonView() {
    const { $t } = useNuxtApp();

    // 国内只能联系顾问
    if (isChinese()) {
      if (this.isUserLogin) {
        return this.getButton({
          text: $t('zi-xun-gu-wen'),
          cb: this.openContact,
        });
      }
      return this.getButton({
        text: $t('le-jie-geng-duo'),
        cb: this.openContact,
      });
    }

    // 海外可以直接购买
    if (this.isSameRights() && this.isAdmin) {
      return this.getButton({
        text: $t('li-ji-xu-fei'),
        cb: this.renewOrder,
      });
    }
    return this.getButton({
      text: $t('li-ji-ding-yue'),
      cb: this.newOrder,
    });
  }

  openContact(url?: string) {
    showContactNew(url || getQrcodeURI('b', '29'));
  }

  // true is limited
  buyLimit() {
    const { $t } = useNuxtApp();

    if (!this.isUserLogin) {
      this.toCreateRights16();
      return true;
    }

    if (this.isPersonalAccount) {
      if (this.hasManagedRights1516()) {
        message.info(
          <div>
            {$t('dang-qian-wei-ge-ren-zhang-hao-ru-xu-gou-mai-tuan-dui-tao-can-qing')}
            <a class="mx-[4px]" onClick={this.switchAccount}>
              {$t('qie-huan-zhang-hao')}
            </a>
            {$t('jin-hang-gou-mai-huo')}
            <a class="mx-[4px]" onClick={this.toCreateRights16}>
              {$t('xin-jian-tuan-dui-sheng-ji')}
            </a>
          </div>
        );
      } else {
        this.toCreateRights16();
      }

      return true;
    }
    if (this.isRights2122) {
      if (this.hasManagedRights1516()) {
        message.info(
          <div>
            {$t(
              'dang-qian-yi-gou-mai-qi-ye-tao-can-zan-bu-zhi-chi-gou-mai-ru-men-ban-tao-can-shi-fou'
            )}
            <a onClick={this.switchAccount}>{$t('qie-huan-zhang-hao')}</a>
            {$t('gou-mai-huo')}
            <a onClick={this.toCreateRights16}>{$t('xin-jian-tuan-dui-sheng-ji')}</a>，
            {$t('ru-you-qi-ta-wen-ti-qing-lian-xi-nin-de-shang-wu-fu-ze-ren-0')}
          </div>
        );
      } else {
        message.info(
          <div>
            {$t(
              'dang-qian-yi-gou-mai-qi-ye-tao-can-zan-bu-zhi-chi-gou-mai-ru-men-ban-tao-can-shi-fou'
            )}
            <a onClick={this.toCreateRights16}>{$t('xin-jian-tuan-dui-sheng-ji')}</a>，
            {$t('ru-you-qi-ta-wen-ti-qing-lian-xi-nin-de-shang-wu-fu-ze-ren-0')}
          </div>
        );
      }
      return true;
    }
    if (this.isOrgMember) {
      if (this.hasManagedRights1516()) {
        message.info(
          <div>
            {$t(
              'tuan-dui-tao-can-jin-yun-xu-guan-li-yuan-jin-hang-gou-mai-sheng-ji-qing-lian-xi-guan-li-yuan-jin-hang-gou-mai-ru-xu-sheng-ji-qi-ta-zhang-hao-qing'
            )}
            <a onClick={this.switchAccount}>{$t('qie-huan-zhang-hao')}</a>
            {$t('huo')}
            <a onClick={this.toCreateRights16}>{$t('xin-jian-tuan-dui-sheng-ji')}</a>
          </div>
        );
      } else {
        message.info(
          <div>
            {$t(
              'tuan-dui-tao-can-jin-yun-xu-guan-li-yuan-jin-hang-gou-mai-sheng-ji-qing-lian-xi-guan-li-yuan-jin-hang-gou-mai-huo'
            )}
            <a onClick={this.toCreateRights16}>{$t('xin-jian-tuan-dui-sheng-ji')}</a>
          </div>
        );
      }
      return true;
    }
    return false;
  }

  public newOrder = async () => {
    if (this.buyLimit()) {
      return false;
    }

    await this.buy({
      title: this.rights.rights_name,
      behavior: ORDER_BEHAVIOR.BUY,
      order_type: ORDER_TYPE.PACKAGE,
      meta: 'annual',
    });
    return true;
  };

  public renewOrder = async () => {
    if (this.buyLimit()) {
      return false;
    }

    await this.buy({
      title: this.rights.rights_name,
      behavior: ORDER_BEHAVIOR.RENEW,
      order_type: ORDER_TYPE.PACKAGE,
      meta: 'annual',
    });
    return true;
  };
}
